<template>
  <template v-if="hasContent">
    <transition-fade :duration="500" appear>
      <teacher-box
        id="teacher-box-1"
        :title="activeSeasonContentForSchoolLevel?.teacherTitle1"
        :content="activeSeasonContentForSchoolLevel?.teacherContent1"
      />
    </transition-fade>
    <transition-fade :duration="500" appear>
      <teacher-box
        id="teacher-box-2"
        :title="activeSeasonContentForSchoolLevel?.teacherTitle2"
        :content="activeSeasonContentForSchoolLevel?.teacherContent2"
      />
    </transition-fade>
    <transition-fade :duration="500" appear>
      <teacher-box
        id="teacher-box-3"
        :title="activeSeasonContentForSchoolLevel?.teacherTitle3"
        :content="activeSeasonContentForSchoolLevel?.teacherContent3"
      />
    </transition-fade>
  </template>
  <div v-else class="flex h-full justify-center items-center">
    <box-generic header="Geen materiaal" h-stretch>
      <p class="leading-relaxed">
        In deze aflevering zijn er geen materialen<br />
        voor het onderdeel “Leerkracht” beschikbaar.
      </p>
    </box-generic>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import TeacherBox from "../../../../components/content/season/TeacherBox.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

import lightboxInitialize from "../../../../components/content/lightbox-initialize";
import lightboxDestroy from "../../../../components/content/lightbox-destroy";

export default {
  name: "TeacherContent",
  components: {
    BoxGeneric,
    TeacherBox,
    TransitionFade,
  },
  computed: {
    ...mapGetters(["activeSeasonContentForSchoolLevel"]),
    hasContent() {
      return [
        "teacherTitle1",
        "teacherContent1",
        "teacherTitle2",
        "teacherContent2",
        "teacherTitle3",
        "teacherContent3",
      ].some((key) => this.activeSeasonContentForSchoolLevel?.[key].length);
    },
  },
  watch: {
    activeSeasonContentForSchoolLevel() {
      this.$nextTick(() => {
        lightboxDestroy();
        lightboxInitialize();
      });
    },
  },
  mounted() {
    lightboxInitialize();
  },
  beforeUnmount() {
    lightboxDestroy();
  },
};
</script>

<style scoped lang="css">
.teacher-box {
  font-weight: 400;
  margin-bottom: 1.5625em;
  margin-right: 3.5625em;
  max-width: 48%;

  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;

  &:not(:last-child) {
    max-height: 60%;
  }

  &:last-child {
    max-height: 100%;
  }

  @media (max-width: 1050px) {
    &:not(:last-child) {
      max-width: 44%;
    }
    &:last-child {
      max-width: 52%;
    }
  }
  & .teacher-box-content .Button,
  & .teacher-box-content .Button--primary {
    @apply font-sans;
  }
}
</style>
